function dispatchRerender() {
  // Dispatch event to re-attach orbit functionality.
  if (typeof document !== 'undefined') {
    document.dispatchEvent(new Event('react-rerender'));
  }
}

export default dispatchRerender;
